import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { formatCurrency } from '../../utils/formatters';

const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <ReceiptIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * DistributionEntryInvoiceSection - Mirrors the Capa Rel. Imp. NF ENTRADA block.
 * Invoice Total = Customs Value + Federal Taxes + Customs Expenses
 * (Inland Freight is NOT part of the entry invoice total).
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const DistributionEntryInvoiceSection = ({ order }) => {
  if (!order) return null;

  const taxCalculation = order.latest_tax_calculation || {};
  const exchangeRate = taxCalculation.exchange_rate_dollar_to_real || 1;

  const valorAduaneiro = Number(taxCalculation.valor_aduaneiro_brl) || 0;
  const tributosFederais = Number(taxCalculation.tributos_alfandegarios_brl) || 0;
  const despesasAduaneiras = Number(taxCalculation.despesas_aduaneiras) || 0;
  const totalNotaFiscal = valorAduaneiro + tributosFederais + despesasAduaneiras;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="ENTRY INVOICE" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="Customs Value"
                valueBRL={valorAduaneiro}
                valueUSD={taxCalculation.valor_aduaneiro_usd}
              />
              <FinancialRow
                label="Federal Taxes"
                valueBRL={tributosFederais}
                valueUSD={taxCalculation.tributos_alfandegarios_usd}
              />
              <FinancialRow
                label="Customs Expenses"
                valueBRL={despesasAduaneiras}
                valueUSD={despesasAduaneiras / exchangeRate}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Invoice Total</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(totalNotaFiscal, 'BRL')}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(totalNotaFiscal / exchangeRate, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default DistributionEntryInvoiceSection;
